import prod from './prod.json';
import test from './test.json';

const nikeStoreCountries = (process.env.NODE_ENV || '').toLowerCase() === 'production' ? prod : test;

export default nikeStoreCountries;
